import React from 'react';
import { ChevronDown } from 'lucide-react';
import siteConfig from '../config/contentConfig';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToNext = () => {
    const howToBuySection = document.getElementById('how-to-buy');
    if (howToBuySection) {
      howToBuySection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen bg-gradient-to-br from-[#FFD600] via-[#FFE033] to-[#FFD600] flex items-center justify-center overflow-hidden"
    >
      {/* Floating Background Elements */}
      <div className="floating-bg-element w-96 h-96 bg-white/30 -top-20 -left-20 animate-float-slow" />
      <div className="floating-bg-element w-64 h-64 bg-white/20 top-40 right-20 animate-float" />
      <div className="floating-bg-element w-80 h-80 bg-white/25 bottom-20 left-1/4 animate-float-slow" />

      <div className="section-container relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-center lg:text-left space-y-6 animate-slide-up">
            <h1
              data-testid="hero-title"
              className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-tight"
            >
              {siteConfig.brand.heroTitle}{' '}
              <span className="text-[#32B44A] block mt-2">
                {siteConfig.token.symbol}
              </span>
            </h1>

            <p className="text-xl sm:text-2xl font-bold text-black/80">
              {siteConfig.brand.heroSubtitle}
            </p>

            <p className="text-lg text-black/70 max-w-xl">
              {siteConfig.brand.heroDescription}
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start pt-4">
              <Button
                data-testid="hero-buy-button"
                onClick={() => window.open(siteConfig.links.buyNana, '_blank')}
                size="lg"
                className="bg-[#32B44A] hover:bg-[#28A745] text-white font-bold text-lg px-8 py-6 shadow-xl btn-press animate-pulse-glow"
              >
                Buy $NANA Now →
              </Button>
              <Button
                data-testid="hero-telegram-link"
                onClick={() => window.open(siteConfig.links.telegram, '_blank')}
                size="lg"
                variant="outline"
                className="bg-black/10 border-2 border-black text-black hover:bg-black hover:text-[#FFD600] font-bold text-lg px-8 py-6 btn-press"
              >
                Join Community
              </Button>
            </div>

            {/* Contract Address Display */}
            <div className="mt-4">
              <div className="text-xs uppercase tracking-wider text-black/60 mb-1 font-semibold">
                Contract Address
              </div>
              <div
                data-testid="hero-contract-copy-btn"
                className="glass px-4 py-3 rounded-xl font-mono text-xs sm:text-sm text-black/80 break-all max-w-2xl"
              >
                {siteConfig.token.contractAddress}
              </div>
            </div>
          </div>

          {/* Right Mascot Video */}
          <div className="flex justify-center lg:justify-end relative">
            <video
              data-testid="hero-mascot-video"
              autoPlay
              loop
              muted
              playsInline
              poster={siteConfig.images.heroMascot}
              className="w-full max-w-md lg:max-w-lg animate-float drop-shadow-2xl rounded-3xl bg-transparent"
              style={{ objectFit: 'contain' }}
              onLoadedData={(e) => {
                // Ensure video plays on load
                e.target.play().catch(() => {
                  console.log('Video autoplay prevented by browser');
                });
              }}
            >
              <source
                src="https://customer-assets-4nw71qhi.emergentagent.net/job_bd24f06d-c257-44d3-b821-05bccf021a15/artifacts/8m063cqu_generated_video.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 cursor-pointer animate-bounce"
        onClick={scrollToNext}
      >
        <ChevronDown size={40} className="text-black/50" />
      </div>
    </section>
  );
};

export default Hero;
